import type React from 'react';

import { Avatar } from '@change/ds-core-ui/Avatar';
import { Text } from '@change/ds-core-ui/Text';
import { CDotIcon } from '@change/ds-icons/CDotIcon';

import type { PetitionUpdateAuthor } from './hooks/usePetitionUpdateByLine';
import { usePetitionUpdateByLine } from './hooks/usePetitionUpdateByLine';

export const PetitionUpdateByLine: React.FC<EmptyProps> = () => {
	const {
		data: { author },
	} = usePetitionUpdateByLine();

	return (
		<div className="flex flex-row items-center gap-3">
			<PetitionUpdateByLineAvatar author={author} />
			<div className="flex flex-col gap-2">
				<Text variant="body" size="large" fontWeight="bold">
					{author.displayName}
				</Text>
				{author.location && (
					<Text fontWeight="light" variant="body" className="text-typography-weak">
						{author.location}
					</Text>
				)}
			</div>
		</div>
	);
};

const PetitionUpdateByLineAvatar: React.FC<{ author: PetitionUpdateAuthor }> = ({ author }) => {
	if (author.type === 'news') {
		return null;
	}
	if (author.type === 'staff') {
		return <CDotIcon size="x-large" className="text-icon-brand" />;
	}
	return <Avatar src={author.photoUrl} alt="" size="large" />;
};
